import React from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import './RecordPlayer.scss';
import playIcon from './icons/play-icon.svg';
import pauseIcon from './icons/pause-icon.svg';

export function RecordPlayer({ audioUrl }: { audioUrl: string }) {
  return (
    <>
      <div className="audio-player-custom">
        <AudioPlayer
          src={audioUrl}
          customVolumeControls={[]}
          showJumpControls={false}
          crossOrigin="anonymous"
          customAdditionalControls={[]}
          customIcons={{
            play: (
              <span className="button-body">
                <span className="button-body__img">
                  <img className="play-icon" src={playIcon} />
                </span>
                <span className="button-body__text">Listen to recording</span>
              </span>
            ),
            pause: (
              <span className="button-body">
                <span className="button-body__img">
                  <img className="pause-icon" src={pauseIcon} />
                </span>
                <span className="button-body__text">Stop</span>
              </span>
            ),
          }}
        />
      </div>
    </>
  );
}
